import { useEffect } from "react";
import { useSettings } from "../hooks/useSettings";

export const setMeta = (name, content) => {
    if (!content) return;
    let el = document.querySelector(`meta[name="${name}"]`) || document.querySelector(`meta[property="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        if (name.startsWith("og:")) el.setAttribute("property", name);
        else el.setAttribute("name", name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

export const usePageKeywords = (pageKey) => {
    const settings = useSettings();
    useEffect(() => {
        const kw = settings?.page_keywords?.[pageKey];
        if (Array.isArray(kw) && kw.length) setMeta("keywords", kw.join(", "));
    }, [settings, pageKey]);
};
